/**
 * Shim for @vertex-protocol/indexer-client
 *
 * Re-exports @nadohq/indexer-client and adds the missing
 * `calcIndexerLpBalanceValue` function which was present in the original
 * Vertex SDK but removed in the Nado fork (LP products not supported).
 */
/* eslint-disable @typescript-eslint/no-require-imports */
const BigNumber = require('bignumber.js').default || require('bignumber.js');

// Static require so webpack can resolve and bundle this dependency.
// (require.resolve() is a Node-only API and fails in browser bundles.)
let indexerClient = {};
try {
  indexerClient = require('@nadohq/indexer-client');
} catch (_e) {
  console.warn('[vertex-indexer-client shim] Could not load @nadohq/indexer-client');
}

module.exports = {
  ...indexerClient,

  // calcIndexerLpBalanceValue: LP positions not used in Stackd Perps — stub returns 0
  calcIndexerLpBalanceValue: (_balance, _market) => new BigNumber(0),

  // calcIndexerLpTokenValue: similarly stubbed
  calcIndexerLpTokenValue: (_balance, _market) => new BigNumber(0),
};
